module.exports = __webpack_public_path__ + "img/canales-efecty.2142ec6b.svg";